const HamburgerIcon = () => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 32 31"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="4" y="6" width="24" height="1" fill="#514F4E" />
    <rect x="4" y="15" width="24" height="1" fill="#514F4E" />
    <rect x="4" y="24" width="24" height="1" fill="#514F4E" />
  </svg>
);

export default HamburgerIcon;
